import clienteAxios from "../services/axios"
import { authHeader } from "../helpers/auth-header"
import { useDispatch, useSelector } from "react-redux"
import { TOKEN_INVALID } from "../types/index"
export const buildContentService = {
	conceptList,
	conceptSave,
	conceptIndividual,
	topicBuilder,
	conceptListWithCount,
	removeConceptAPI,
	topicJob,
	getJob,
	getSearchJobId,
	getStatusJobId,
	searchJobId,
	getConcept,
	phrasecountRequest,
	setDocCount,
}

function conceptList() {
	// return clienteAxios.get('/concept/allwithdoccounts',{"headers": authHeader()});
	return clienteAxios.get("/concept", { headers: authHeader() })

	//return clienteAxios.get('/concept/all',null);
}

function getConcept(conceptId) {
	return clienteAxios.get("/concept/" + conceptId, { headers: authHeader() })
}

function getSearchJobId(concept) {
	return clienteAxios.post("/p_search", concept, { headers: authHeader() })
}

function getStatusJobId(jobId) {
	return clienteAxios.get("/job/" + jobId, { headers: authHeader() })
}

function searchJobId(jobId) {
	return clienteAxios.get("/p_search/" + jobId, { headers: authHeader() })
}

function conceptListWithCount() {
	/*
    var lastCall = new Date();
    var difference = lastCall.getTime() - callTime.getTime(); //callTime habría que pasarla como parámetro a la función.
    var minutesDifference = Math.floor(difference/1000/60);

    if (minutesDifference > 5){
        return clienteAxios.get('/concept/allwithdoccounts',{"headers": authHeader()});
    }
    */

	return clienteAxios.get("/concept/allwithdoccounts", { headers: authHeader() })
}

function conceptSave(concept) {
	if (concept?.id) {
		return clienteAxios.put("/concept", concept, { headers: authHeader() })
	} else {
		return clienteAxios.post("/concept", concept, { headers: authHeader() })
	}

	/* //OLD API    
    return clienteAxios.post('/concept/save',concept, {"headers": authHeader()});
    */
}

function setDocCount(concept_id) {
	return clienteAxios.post("/concept/set_doccount/" + concept_id, {}, { headers: authHeader() })
}

function conceptIndividual(ext_id) {
	/* OUTPUT PARAMETERS
    {
            "data": {
                "description": "missiles",
                "editable": true,
                "ext_id": "mrROgOQH3QFcxfhiki8VPUZM",
                "owner": "changethisabit",
                "shared": 1,
                "topic": {
                    "count": [
                        
                    ],
                    "relatedness": [
                        
                    ],
                    "terms": [
                        
                    ]
                },
                "visual": {
                    "ignore": [],
                    "phrase_count": "25",
                    "soft_ignore": [],
                    "strict": "false",
                    "terms": [
                        "missiles"
                    ]
                }
            }
        }
    */

	return clienteAxios.get("/concept/" + ext_id, { headers: authHeader() })
}

function topicBuilder(data) {
	try {
		if (data.phrase_count > 200) {
			data.phrase_count = 200
		}
		if (data.neg_phrase_count > 20) {
			data.neg_phrase_count = 20
		}
	} catch (e) {}

	/* INPUT PARAMETERS 
        ignore_terms : list of "ignore related" terms ,

            target_terms : list of " target terms" terms ,

            phrase_count : int / number of positive terms ,

            strict : boolean / false for getting phrases with negative connotations.
            */
	// return clienteAxios.post(`/topicBuilder_api`,data, {"headers": authHeader()});
	return clienteAxios.post(`/p_topic`, data, { headers: authHeader() })
}

function removeConceptAPI(ext_id) {
	return clienteAxios.delete("/concept?concept_id=" + ext_id, { headers: authHeader() })
}

// eslint-disable-next-line
function phrasecountRequest(items) {
	return clienteAxios.get(`/phrasecount`, items, { headers: authHeader() })
}

function getJob(jobId) {
	return clienteAxios.get(`/job/` + jobId, { headers: authHeader() })
}

function topicJob(topicJobId) {
	return clienteAxios.get(`/p_topic/` + topicJobId, { headers: authHeader() })
}
